import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, Button, Label, FormGroup, Spinner } from 'reactstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { registerVacation } from '../../../store/ducks/humanResources'

class VacationRequest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      initialDate: '',
      finalDate: '',
    }
    this.files = React.createRef()
  }

  handleSubmit = () => {
    const { registerVacation } = this.props
    const { initialDate, finalDate } = this.state

    const data = {
      initialDate,
      finalDate,
    }

    return registerVacation(data)
  }

  render() {
    const { initialDate, finalDate } = this.state
    const { registerVacationIsLoading } = this.props.humanResources

    return (
      <div className="page-content">
        <Container fluid style={{ minHeight: 500 }}>
          <Breadcrumbs
            title="Registro de férias"
            breadcrumbItems={[{
              title: '',
            }]}
          />
          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Data inicial</Label>
                <DatePicker
                  locale="pt-BR"
                  className="form-control"
                  selected={initialDate}
                  dateFormat="dd/MM/yyyy"
                  /* minDate={new Date()} */
                  filterDate={date => {
                    const day = moment(date).day()
                    return day !== 0 && day !== 6 && day !== 5
                  }}
                  onChange={initialDate => {
                    this.setState({ initialDate, finalDate: '' })
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Data final</Label>
                <DatePicker
                  locale="pt-BR"
                  disabled={!initialDate}
                  className={!initialDate ? 'form-control input-disabled' : 'form-control'}
                  selected={finalDate}
                  dateFormat="dd/MM/yyyy"
                  minDate={initialDate ? new Date(initialDate.valueOf() + 4000 * 3600 * 24) : null}
                  filterDate={date => {
                    const day = moment(date).day()
                    return day !== 0 && day !== 6
                  }}
                  onChange={finalDate => this.setState({ finalDate })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Button
            className="mt-2"
            color="primary"
            type="button"
            disabled={
              registerVacationIsLoading
              || !initialDate
              || !finalDate
            }
            onClick={() => this.handleSubmit()}
          >
            Enviar
            {registerVacationIsLoading && (
              <Spinner size="sm" className="ml-2" />
            )}
          </Button>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({ registerVacation }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(VacationRequest)
